export class Token {
    userId: number;
    EmailAddress: string;    
  documentNumber: string;
}